import { ApiResponse, ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import { logOut, setCredentials } from "./authSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    riderApplication: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (userData) => ({
        url: "/v1/ridderapplication/apply",
        method: "POST",
        body: { ...userData },
      }),
    }),
    login: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (credentials) => ({
        url: "/webtokens",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    sendLogout: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: () => ({
        url: "/webtokens/logout",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          console.log(data);
          dispatch(logOut());
          setTimeout(() => {
            dispatch(apiSlice.util.resetApiState());
          }, 1000);
        } catch (err) {
          console.log(err);
        }
      },
    }),
    refresh: builder.mutation<ApiSuccessResponse<any>, void>({
      query: () => ({
        url: "/webtokens/refresh",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            setCredentials({
              accessToken: data?.data?.token,
              user: data?.data?.userDetails,
              permissions: data?.data?.permissions,
            })
          );
        } catch (err) {
          console.log(err);
        }
      },
    }),
    getUser: builder.query<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/personal/profile`,
        method: "GET",
      }),
      transformResponse: (response: ApiResponse<any>) => {
        console.log(response);
        return response.data;
      },
    }),
    getUserPermission: builder.query<ApiSuccessResponse<any>, string>({
      query: () => ({
        url: `/personal/permission`,
        method: "GET",
      }),
    }),
    riderApplicationStatus: builder.query<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/ridderapplication/status?TrackingId=${id}`,
        method: "GET",
      }),
    }),
    updateUser: builder.mutation<void, Record<string, any>>({
      query: (userData) => ({
        url: `/users/staff/${userData.id}`,
        method: "PUT",
        body: { ...userData },
      }),
    }),
    sendResetPasswordMail: builder.mutation<ApiResponse<any>, string>({
      query: (email) => ({
        url: "/auth/send-reset-password-mail",
        method: "POST",
        body: { email },
      }),
    }),
    verifyUserToken: builder.mutation<ApiResponse<any>, string>({
      query: (token) => ({
        url: "/auth/verify-user-token",
        method: "POST",
        body: { token },
      }),
    }),
    resetPassword: builder.mutation<ApiResponse<any>, Record<string, any>>({
      query: (userData) => ({
        url: "/auth/reset-password",
        method: "POST",
        body: { ...userData },
      }),
    }),
  }),
});

export const {
  useRiderApplicationMutation,
  useLoginMutation,
  useSendLogoutMutation,
  useRefreshMutation,
  useGetUserQuery,
  useGetUserPermissionQuery,
  useRiderApplicationStatusQuery,
  useUpdateUserMutation,
  useSendResetPasswordMailMutation,
  useVerifyUserTokenMutation,
  useResetPasswordMutation,
} = authApiSlice;
